module.exports = __webpack_public_path__ + "static/media/confirmNavigation.a0881f12.svg";